export enum IbmRegion {
    Dallas = 'us-south',
    'Washington, DC' = 'us-east',
    Frankfurt = 'eu-de',
    Sydney = 'au-syd',
    Tokyo = 'jp-tok',
    London = 'eu-gb',
    Seoul = 'kr-seo'
}